import script from "./courseList.vue?vue&type=script&setup=true&lang=js"
export * from "./courseList.vue?vue&type=script&setup=true&lang=js"

import "./courseList.vue?vue&type=style&index=0&id=00f3a7bd&lang=scss&scoped=true"
import "./courseList.vue?vue&type=style&index=1&id=00f3a7bd&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f3a7bd"]])

export default __exports__